import React from 'react';
import axios from 'axios'
import AppVars from '../../AppVars.js';
import Logger from '../../Logger.js';

import {constants} from '../../constants/constants'
import ResetParentView from '../Views/TO/Reset/ResetParentView.js';
import {parseCookies, isValidGoToURL} from 'account-portal-library/lib/helperFunctions'

let appVars = AppVars.getInstance()
let logger = Logger.getInstance();


class ResetParent extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            ...props,
            showForm: "",
            code: "",
            loginURI: "",
            passwordLoading: false,
            firstName:"",
            lastName: "",
            email: ""
        };
        this.setEmail = this.setEmail.bind(this);
        this.displayForm = this.displayForm.bind(this);
    }

    async componentDidMount() {
        // Get the code value and branch based on whether or not it is present

        let code = this.parseCodeFromURL();
        this.setState({
            code: code,
            // loginURI: this.parseRedirectFromURL()
        });
        if (code) {
            this.setState({ passwordLoading: true })
            this.validatePasswordCode(code)
        }
        else {
            this.setState({ passwordLoading: false })
            window.location.href = "/register"
        }
    }

    async validatePasswordCode(code, brand='T') {
        await axios({
            method: 'get',
            url: appVars.getAPIGatewayURL() + "/ValidateCode/" + code,
            // url: '/v2/admin/account/activation/validate/' + code + '?codeType=password',
            headers: {
                'X-BRAND': brand,
                "x-client" : "FR-Portal-Toyota",
                //"x-client" : "SI-REG"
            }
        })
        .then((resp) => this.handleValidatePasswordCode(resp))
        .catch((err) => this.handleValidatePasswordCodeError(err))
    }

    handleValidatePasswordCode(resp) {
        var res = resp.data
        if (res && res['activationEntry']['redirectURI']) {
            this.setState({
                loginURI:  decodeURIComponent(res['activationEntry']['redirectURI'])
            });
        }
        this.setState({
            passwordLoading: false,
            showForm: "PASSWORD"
        });
    }


    handleValidatePasswordCodeError(err) {
        var error = err.response.data;
        if (error['status'] == 400) {
            if (typeof error['status']['messages'] !== 'undefined') {
                if (error['status']['messages'][0]['code'] == constants.USER_ALREADY_ACTIVATED) {
                    this.setState({
                        passwordLoading: false,
                        showForm: "USED"
                    });
                    // this.passwordStateService.changeState('USED');
                } else if (error['status']['messages'][0]['code'] == constants.ACTIVATION_CODE_EXPIRED) {
                    this.setState({
                        passwordLoading: false,
                        showForm: "EXPIRED"
                    });
                    // this.passwordStateService.changeState('EXPIRED');
                } else if (error['status']['messages'][0]['code'] == constants.INVALID_ACTIVATION_CODE) {
                    this.setState({
                        passwordLoading: false,
                        showForm: "INVALID"
                    });
                    // this.passwordStateService.changeState('INVALID');
                } else {
                    this.setState({
                        passwordLoading: false,
                        showForm: "ERROR"
                    });
                    // this.passwordStateService.changeState('ERROR');
                }
            }
        } else if (error['status'] == 500) {
            this.setState({
                passwordLoading: false,
                showForm: "ERROR"
            });
        // DCS3 doesn't have this but I added it to catch 404's and other miscallenous errors
        } else {
            this.setState({
                passwordLoading: false,
                showForm: "ERROR"
            });
        }
    }

    parseCodeFromURL() {
        let search = window.location.search;
        let params = new URLSearchParams(search);
        let code = params.get('code');
        return encodeURIComponent(code)
    }

    parseRedirectFromURL() {
        const parsedCookies = parseCookies(document.cookie);
        if (Object.keys(parsedCookies).includes("login_uri") && isValidGoToURL('T', parsedCookies["login_uri"])){
            var redirectURI = parsedCookies["login_uri"]
        }
        else if (Object.keys(parsedCookies).includes("login_uri") && isValidGoToURL('S', parsedCookies["login_uri"])){
            var redirectURI = parsedCookies["login_uri"]
        }
        else {
            redirectURI = "/"
        }
        return redirectURI
    }


    displayForm(form){
        this.setState({showForm: form})
    }

    setEmail(value){
        this.setState({email: value})
    }
        

    
    render(){
        return(
            <ResetParentView
            email = {this.state.email}
            passwordLoading = {this.state.passwordLoading}
            showForm = {this.state.showForm}
            code = {this.state.code}
            loginURI = {this.state.loginURI}
            setEmail = {this.setEmail}
            displayForm = {this.displayForm}
            style = "DG"
            />
          
    );

    }

}

export default ResetParent;